<template>
  <div id="app">
     <!-- 导航栏 -->
    <div class="pcWeb">
      <div class="indexNavOut">
        <div class="logo"><img :src="logo" class="zimi-logo"></div>
          <div class="indexNav">
            <ul class="navLi">
              <router-link v-for="(item,index) of list" :key="index" :to="item.router">
                <li :class="{active: isActive === index}"  @click="changeClass(index)">
                  <a href="" style="width:100px">{{item.title}}</a>
                </li>
              </router-link>
            </ul>
          </div>
        </div>
        <router-view/>
        <div class="footer">
            <div>
              <div style="padding-top:48px;padding-bottom:28px;"><img src="./assets/images/footer-logo.png" alt=""></div>
              <div class="icon-web">© 深圳市字米网络科技有限公司. All Rights Reserved <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#fff">粤ICP备2020115013号 </a><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030702004430" target="_blank"  style="color:#fff"><img src="./assets/images/guo.png" style="vertical-align: middle;margin-top: -5px;"> 粤公网安备 44030702004430号</a></div>
            </div>
        </div>
      </div>

  </div>
</template>

<script>
// import  nav  from "./components/nav.vue";
export default {
  name: 'App',
  data () {
    return {
      list: [
        {
          title: '首页',
          router: '/'
        },
        {
          title: '字米WMS',
          router: '/WMS'
        },
        // {
        //   title: '字米TMS',
        //   router: '/TMS'
        // },
        {
          title: '联系我们',
          router: '/contactUs'
        },
      ],
      homePage:require('./assets/images/homepage-logo.png'),
      isActive: 0,
      logo: require('./assets/images/zimi-logo.png'),
      pc: true
    }
  },
  created() {
    this.pc = localStorage.getItem('pc');
    if(localStorage.getItem('menu')){
      this.isActive = Number(localStorage.getItem('menu'));
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
     changeClass (i) {
      this.isActive = i;
      localStorage.setItem('menu',i);
      var zimi = document.getElementsByClassName('zimi-logo');
      var home = document.getElementsByClassName('navLi');
      var out = document.getElementsByClassName('indexNavOut');
      if(localStorage.getItem('menu')==2){
        zimi[0].style = 'margin-top:40px';
        home[0].style = 'top:25px';
        out[0].style = 'background-color:none';
        home[0].classList.add('blank');
        this.logo = require('./assets/images/zimi-logo-b.png');
      }else{
        zimi[0].style = 'margin-top:40px';
        home[0].style = 'top:25px';
        out[0].style = 'background-color:none';
        home[0].classList.remove('blank');
        this.logo = require('./assets/images/zimi-logo.png');
      }
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      document.body.scrollTop = document.documentElement.scrollTop = top = 0
    },
     handleScroll(e) {
      var scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
      var zimi = document.getElementsByClassName('zimi-logo');
      var home = document.getElementsByClassName('navLi');
      var out = document.getElementsByClassName('indexNavOut');
      if(localStorage.getItem('menu')==2&&scrollTop < 200){
        zimi[0].style = 'margin-top:40px';
        home[0].style = 'top:25px';
        out[0].style = 'background-color:none';
        home[0].classList.add('blank');
        this.logo = require('./assets/images/zimi-logo-b.png');
      }else if(scrollTop > 200) {
        zimi[0].style = 'margin-top:9px';
        home[0].style = 'top:0px';
        out[0].style = 'background-color:#fff';
        home[0].classList.add('blank');
        this.logo = require('./assets/images/zimi-logo-b.png');
      }else{
        zimi[0].style = 'margin-top:40px';
        home[0].style = 'top:25px';
        out[0].style = 'background-color:none';
        home[0].classList.remove('blank');
        this.logo = require('./assets/images/zimi-logo.png');
      }
    },

  },
  // components: {
  //   nav
  // }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 18px;

  /* margin-top: 60px; */
}
a {
  text-decoration: none!important;
}
.zimi-title {
    position: absolute;
    top: 328px;
    z-index: 1;
    left: 14%;
    text-align: left;
    width: 400px;
}
.zimi-title1 {
    position: absolute;
    top: 198px;
    z-index: 1;
    left: 18%;
    text-align: left;
    width: 600px;
    color: #fff;
}
.zimi-title-1 {
    position: absolute;
    top: 198px;
    z-index: 1;
    left: 18%;
    text-align: left;
    width: 600px;
    color: #000;
}
.zimi-title2 {
    position: absolute;
    top: 328px;
    z-index: 1;
    left: 24%;
    text-align: left;
    width: 600px;
}
/* 导航栏 */
.indexNavOut{
    /* background-color: #486B8A; */
    height: 60px;
    position: fixed;
    width: 100%;
    display: flex;
    align-items: center;
    z-index: 2;
}
.logo {
    width: 70%;
    height: 60px;
}
.logo img {
    float: left;
    margin-left: 157px;
    margin-top: 40px;
}
.indexNav{
    width: 25%;
    float: right;
    margin-right: 128px;
}
.navLi{
    display: flex;
    flex: 1;
    position: relative;
    top: 25px;
}
.navLi li:nth-child(1){
    flex: 1.8;
 }
 .navLi li {
    width: 120px;
    list-style-type:none;
    text-align: right;
    text-decoration: none;
    /* width: 28px; */
    /* height: 14px; */
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    /* color: #FFFFFF;
    opacity: 0.51; */
 }
.navLi li a{
    text-decoration: none;
    width: 28px;
    height: 14px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 0.51;
}
.blank li a {
    color: #000;
}
.indexNav .icon{
    width: 230px;
    margin-top: 10px;
 }
.indexNav .icon img{
    width: 100%;
}
.navLi {
  margin: 0px;
}
.navLi  li.active a{
    border-bottom: 2px solid rgba(255,255,255,0.77);
    border-radius: 1px;
    opacity: 1;
    padding-bottom: 5px;
    color: #fff;
}
.blank  li.active a{
    border-bottom: 2px solid rgba(0,0,0,0.77);
    border-radius: 1px;
    opacity: 1;
    padding-bottom: 5px;
    color: #000;
}
.navLi li:last-child:after{
    border-right: none;
}
.navLi li .line{
    width: 20px;
    height: 3px;
    background: #E96463;
    border: none;
    position: absolute;
    left: 50px;
    top: 45px;
    z-index: 100;
}
.ziwms {
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 72px;
  letter-spacing: 4px;
  padding-bottom: 2px;
}
.ziwms-content {
  letter-spacing: 3px;
  margin-top: 50px;
  line-height: 30px;
  font-size: 16px;
}
.ziwms-1 {
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #000;
  line-height: 72px;
  letter-spacing: 4px;
  padding-bottom: 2px;
}
.ziwms-content-1 {
  letter-spacing: 3px;
  margin-top: 50px;
  line-height: 30px;
  font-size: 16px;
}
.title1 {
  font-size: 55px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 72px;
  letter-spacing: 1px;
  padding-bottom: 2px;
}
.title2 {
  font-size: 60px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 72px;
  letter-spacing: 8px;
  padding-bottom: 2px;
}
.title3 {
  font-size: 60px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #0777FD;
  line-height: 30px;
  letter-spacing: 3px;
  padding-top: 40px;
}
.decrtion {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 200;
  color: #FFFFFF;
  line-height: 72px;
  letter-spacing: 5px;
  margin-left: 6px;
  margin-top: -15px;
}
.footer {
  height: 206px;
  background: #222222;

}
.icon-web {
  width: 700px;
  height: 15px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #FFFFFF;
  line-height: 30px;
  margin:0 auto;
}
.zimi-title1 .more {
    margin-top: 40px;
    height: 49px;
    background:url('./assets/images/yuyue.png') no-repeat;
    width: 205px;
    padding-top: 10px;
    text-align: center;
  }
  .zimi-title1 .more span {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 34px;
    margin-right: 10px;
  }
  .zimi-title-1 .more {
    margin-top: 40px;
    height: 49px;
    background:url('./assets/images/yuyue-1.png') no-repeat;
    width: 205px;
    padding-top: 10px;
    text-align: center;
  }
  .zimi-title-1 .more span {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 34px;
    margin-right: 10px;
  }
  .zimi-title-1 .more-1 {
    margin-top: 40px;
    height: 49px;
    background:url('./assets/images/yuyue-2.png') no-repeat;
    width: 205px;
    padding-top: 10px;
    text-align: center;
  }
  .zimi-title-1 .more-1 span {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
   color: #032779;
    line-height: 34px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue